import { m } from 'framer-motion';

import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { ServerErrorIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

import { ContentRoot } from '../EmptyState';

// ----------------------------------------------------------------------

export function ErrorPage() {
  return (
    <ContentRoot>
      <Container component={MotionContainer}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <m.div variants={varBounce('in')}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              Something went wrong
            </Typography>
          </m.div>

          <m.div variants={varBounce('in')}>
            <Typography sx={{ color: 'text.secondary' }}>
              There was an error, please try again later. Our developers have been notified and will
              fix it as soon as possible.
            </Typography>
          </m.div>

          <m.div variants={varBounce('in')}>
            <ServerErrorIllustration sx={{ my: { xs: 5, sm: 10 } }} />
          </m.div>

          <Button component={RouterLink} href="/" size="large" variant="contained">
            Back to Dashboard
          </Button>
        </Box>
      </Container>
    </ContentRoot>
  );
}
